import * as React from 'react';
import { LanguageNameProps } from '../../types';

import styles from './language-name.scss';

export const LanguageName = ({ text, className = '' }: LanguageNameProps) => (
  <div className={`${className}`}>
    <div className={`d-flex ${styles.labelContainer}`}>
      <div className={`d-flex align-self-center ${styles.labelText}`}>
        {text}
      </div>
    </div>
  </div>
);
